import { setElementOnClick, createDivIn, createParagraphIn, createLinkIn, setElementInnerText, setElementInnerHTML } from '../ui_utils/DomUtils.ts';
import { UIAjaxWrapper } from '../network/UIAjaxWrapper.ts';
import { UIAPIEndpoints } from '../network/UIAPIEndpoints.ts';
import { UIUtilsEjsVariables } from '../UIUtilsEjsVariables.ts';
import { buildSectionsFromQualifiers } from './UIChampionship26DataUtils.ts';
import { openSubscriptionOverlayInsteadOfLinkInVariant } from '../store/subscription_overlay/subscriptionOverlayABTest.ts';
export class UIChampionship26Controller {
    showHost() {
        this.hostToggleBtn.classList.add('active');
        this.joinToggleBtn.classList.remove('active');
        this.hostPanel.classList.remove('hidden');
        this.playerPanel.classList.add('hidden');
    }
    showPlayer() {
        this.joinToggleBtn.classList.add('active');
        this.hostToggleBtn.classList.remove('active');
        this.playerPanel.classList.remove('hidden');
        this.hostPanel.classList.add('hidden');
    }
    static async loadContent() {
        try {
            const response = await UIAjaxWrapper.getRequestHandler(UIAPIEndpoints.apiChampionship26Content(), undefined);
            if (response == undefined) return;
            const data = response.json;
            if (data == undefined) return;
            if (Array.isArray(data.qualifiers)) {
                const sections = buildSectionsFromQualifiers(data.qualifiers);
                UIChampionship26Controller.renderQualifiers(sections);
                UIChampionship26Controller.bindQualifiersToggle(sections);
            }
            if (Array.isArray(data.partners)) {
                UIChampionship26Controller.renderPartners(data.partners);
            }
        } catch (e) {
            return;
        }
    }
    static renderQualifiers(sections) {
        const toggleContainer = document.getElementById('championship26-qualifiers-toggle-container');
        const sectionsContainer = document.getElementById('championship26-qualifiers-sections-container');
        setElementInnerHTML(toggleContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        setElementInnerHTML(sectionsContainer, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        const allToggle = createDivIn(toggleContainer, 'toggle-tab', 'championship26-qualifiers-all-toggle-btn');
        setElementInnerText(allToggle, {
            key: 'strings:championship26Page.qualifiers.all'
        });
        for (const section of sections){
            const toggle = createDivIn(toggleContainer, 'toggle-tab' + (section.openByDefault ? ' active' : ''), section.toggleId);
            setElementInnerText(toggle, section.title);
            const sectionDiv = createDivIn(sectionsContainer, 'qualifiers-section' + (section.openByDefault ? '' : ' hidden'), section.contentId);
            if (section.qualifiers.length == 0) {
                createParagraphIn(sectionDiv, {
                    key: 'strings:championship26Page.qualifiers.empty'
                }, '');
                continue;
            }
            const content = createDivIn(sectionDiv, 'qualifiers-section-content');
            for (const qualifier of section.qualifiers){
                const card = createDivIn(content, 'qualifier-card');
                const inner = createDivIn(card, 'qualifier-content');
                createParagraphIn(inner, {
                    key: 'strings:colonistCommon.utils.#buffer',
                    options: {
                        value: qualifier.title
                    }
                }, 'qualifier-title');
                createParagraphIn(inner, qualifier.description, '');
                if (section.showJoinBtns && qualifier.joinUrl) {
                    createLinkIn(card, qualifier.joinUrl, {
                        key: 'strings:championship26Page.qualifiers.join'
                    }, 'button_cta_sub', '', true);
                }
            }
        }
    }
    static bindQualifiersToggle(sections) {
        const allBtn = document.getElementById('championship26-qualifiers-all-toggle-btn');
        const upcomingBtn = document.getElementById('championship26-qualifiers-upcoming-toggle-btn');
        const completedBtn = document.getElementById('championship26-qualifiers-completed-toggle-btn');
        const upcomingSection = document.getElementById('championship26-qualifiers-section-upcoming');
        const completedSection = document.getElementById('championship26-qualifiers-section-completed');
        if (upcomingBtn == null) return;
        if (completedBtn == null) return;
        if (upcomingSection == null) return;
        if (completedSection == null) return;
        setElementOnClick(allBtn, ()=>{
            var _sections_find, _sections_find1;
            allBtn.classList.add('active');
            upcomingBtn.classList.remove('active');
            completedBtn.classList.remove('active');
            var _sections_find_qualifiers_length;
            const upcomingHasContent = ((_sections_find_qualifiers_length = (_sections_find = sections.find((s)=>s.contentId == 'championship26-qualifiers-section-upcoming')) === null || _sections_find === void 0 ? void 0 : _sections_find.qualifiers.length) !== null && _sections_find_qualifiers_length !== void 0 ? _sections_find_qualifiers_length : 0) > 0;
            var _sections_find_qualifiers_length1;
            const completedHasContent = ((_sections_find_qualifiers_length1 = (_sections_find1 = sections.find((s)=>s.contentId == 'championship26-qualifiers-section-completed')) === null || _sections_find1 === void 0 ? void 0 : _sections_find1.qualifiers.length) !== null && _sections_find_qualifiers_length1 !== void 0 ? _sections_find_qualifiers_length1 : 0) > 0;
            upcomingSection.classList.toggle('hidden', !upcomingHasContent && completedHasContent);
            completedSection.classList.toggle('hidden', upcomingHasContent && !completedHasContent);
        }, true);
        setElementOnClick(upcomingBtn, ()=>{
            allBtn.classList.remove('active');
            upcomingBtn.classList.add('active');
            completedBtn.classList.remove('active');
            upcomingSection.classList.remove('hidden');
            completedSection.classList.add('hidden');
        }, true);
        setElementOnClick(completedBtn, ()=>{
            allBtn.classList.remove('active');
            upcomingBtn.classList.remove('active');
            completedBtn.classList.add('active');
            completedSection.classList.remove('hidden');
            upcomingSection.classList.add('hidden');
        }, true);
    }
    static renderPartners(partners) {
        const partnersTitleElement = document.getElementById('championship26-partners-title');
        const viewAllPartnersBtn = document.getElementById('championship26-view-all-partners-btn');
        const partnersGrid = document.getElementById('championship26-partners-grid');
        setElementInnerText(partnersTitleElement, {
            key: 'strings:championship26Page.organization.partnersWithCount',
            options: {
                count: partners.length
            }
        });
        setElementInnerHTML(partnersGrid, {
            key: 'strings:colonistCommon.utils.emptyString'
        });
        for (const partner of partners){
            const item = createDivIn(partnersGrid, 'partner-item');
            if (!UIUtilsEjsVariables.isUserOnDiscord && partner.imageUrl != undefined && partner.imageUrl.length > 0) {
                const partnerImg = document.createElement('img');
                partnerImg.src = partner.imageUrl;
                partnerImg.alt = partner.name;
                item.appendChild(partnerImg);
            }
            const nameDiv = createDivIn(item, 'partner-name');
            setElementInnerText(nameDiv, {
                key: 'strings:colonistCommon.utils.#buffer',
                options: {
                    value: partner.name
                }
            });
        }
        setElementOnClick(viewAllPartnersBtn, ()=>partnersGrid.classList.add('expanded'), true);
    }
    constructor(){
        this.hostToggleBtn = document.getElementById('championship26-host-toggle-btn');
        this.joinToggleBtn = document.getElementById('championship26-join-toggle-btn');
        this.hostPanel = document.getElementById('championship26-host-panel');
        this.playerPanel = document.getElementById('championship26-player-panel');
        setElementOnClick(this.hostToggleBtn, ()=>this.showHost(), true);
        setElementOnClick(this.joinToggleBtn, ()=>this.showPlayer(), true);
        const membershipCtas = document.querySelectorAll('.championship-membership-cta');
        membershipCtas.forEach((membershipCta)=>openSubscriptionOverlayInsteadOfLinkInVariant(membershipCta));
        void UIChampionship26Controller.loadContent();
    }
}
